import React from 'react';
import { RBField, RBInput, RBTextArea } from '../theme';
import AIEnhanceButton from '../AIEnhanceButton';

export default function ProfileStep({ state, setState, sessionId }) {
  const profile = state.profile;
  const update = (key) => (e) =>
    setState((s) => ({ ...s, profile: { ...s.profile, [key]: e.target.value } }));

  return (
    <div className="space-y-4">
      <p className="text-sm text-slate-400">
        These details go at the top of your resume so employers can reach you.
      </p>
      <RBField label="Full name *">
        <RBInput value={profile.name} onChange={update('name')} placeholder="e.g. Asha Kumari" autoComplete="name" />
      </RBField>
      <div className="grid sm:grid-cols-2 gap-4">
        <RBField label="Email *">
          <RBInput type="email" value={profile.email} onChange={update('email')} placeholder="you@example.com" autoComplete="email" />
        </RBField>
        <RBField label="Phone *">
          <RBInput type="tel" value={profile.phone} onChange={update('phone')} placeholder="10-digit mobile number" autoComplete="tel" />
        </RBField>
      </div>
      <RBField label="City / Location">
        <RBInput value={profile.location} onChange={update('location')} placeholder="e.g. Pune, Maharashtra" />
      </RBField>
      <RBField label="About you (2–3 lines)">
        <RBTextArea
          rows={3}
          value={profile.summary}
          onChange={update('summary')}
          placeholder="e.g. Sales executive with 3 years of experience in retail. Good at talking to customers and meeting targets."
        />
        <AIEnhanceButton
          sessionId={sessionId}
          sectionType="profile"
          text={profile.summary}
          onAccept={(t) => setState((s) => ({ ...s, profile: { ...s.profile, summary: t } }))}
        />
      </RBField>
    </div>
  );
}
